import * as Constants from '../constants/auth';

const initialState = {
  authUser: {},
  isAdminUser: false,
  isSuperUser: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_AUTH_USER_SUCCESS: {
      let isAdminUser = false;
      let isSuperUser = false;

      action.payload.groups.forEach((group) => {
        if (group === 'zoetis_administrators') {
          isAdminUser = true;
        }
        if (group === 'zoetis_superusers') {
          isSuperUser = true;
        }
      });
      return {
        ...state,
        authUser: action.payload,
        isAdminUser,
        isSuperUser,
      };
    }
    default:
      return state;
  }
};
